import { render } from "./PresetObjectInput.vue?vue&type=template&id=c27191d2&scoped=true"
import script from "./PresetObjectInput.vue?vue&type=script&lang=js"
export * from "./PresetObjectInput.vue?vue&type=script&lang=js"

import "./PresetObjectInput.vue?vue&type=style&index=0&id=c27191d2&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27191d2"]])

export default __exports__